/**
 * @generated SignedSource<<b4128fee4e4ec26c979b0cc2ca4ae3b4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TxnClassificationEnum = "CHARGEBACK" | "DIVIDEND" | "FINANCING_FEE" | "FRAUDULENT" | "LOAN_PROCEEDS" | "LOAN_REPAYMENT" | "PROCESSOR_FEE" | "REFUND" | "SALARY" | "TAX_PAYMENT" | "TAX_REFUND" | "%future added value";
export type stakeholderTxnsDialog_Query$variables = {
  accountNumber?: string | null | undefined;
  categorized?: boolean | null | undefined;
  counterpartyId?: string | null | undefined;
  from?: string | null | undefined;
  perspectiveId?: string | null | undefined;
  query?: string | null | undefined;
};
export type stakeholderTxnsDialog_Query$data = {
  readonly allStakeholders: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
  readonly expenseNatures: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
  readonly transactions: {
    readonly accounts: ReadonlyArray<{
      readonly nickname: string | null | undefined;
      readonly number: string;
    }>;
    readonly health: ReadonlyArray<{
      readonly categorized: number;
      readonly internal: number;
      readonly period: string;
      readonly uncategorized: number;
    }>;
    readonly limit: number;
    readonly totalCount: number;
    readonly txns: ReadonlyArray<{
      readonly accountNumber: string | null | undefined;
      readonly amount: number;
      readonly attribution: {
        readonly performedAt: string | null | undefined;
        readonly rule: {
          readonly regex: string;
        } | null | undefined;
        readonly source: string;
        readonly user: {
          readonly email: string | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly categoryNode: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
      readonly classification: TxnClassificationEnum | null | undefined;
      readonly description: string;
      readonly expenseNature: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
      readonly internal: boolean;
      readonly kind: string;
      readonly otherBankAccount: {
        readonly number: string;
      } | null | undefined;
      readonly postingDate: string;
      readonly txn: {
        readonly id: string;
      };
    }>;
  };
};
export type stakeholderTxnsDialog_Query = {
  response: stakeholderTxnsDialog_Query$data;
  variables: stakeholderTxnsDialog_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountNumber"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "categorized"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "counterpartyId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "from"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "perspectiveId"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "query"
},
v6 = [
  {
    "kind": "Variable",
    "name": "accountNumber",
    "variableName": "accountNumber"
  },
  {
    "kind": "Variable",
    "name": "categorized",
    "variableName": "categorized"
  },
  {
    "kind": "Variable",
    "name": "counterpartyId",
    "variableName": "counterpartyId"
  },
  {
    "kind": "Variable",
    "name": "from",
    "variableName": "from"
  },
  {
    "kind": "Variable",
    "name": "perspectiveId",
    "variableName": "perspectiveId"
  },
  {
    "kind": "Variable",
    "name": "query",
    "variableName": "query"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "limit",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "number",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nickname",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "period",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "categorized",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uncategorized",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "internal",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "Txn",
  "kind": "LinkedField",
  "name": "txn",
  "plural": false,
  "selections": [
    (v15/*: any*/)
  ],
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postingDate",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountNumber",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "classification",
  "storageKey": null
},
v23 = [
  (v15/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
],
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "ExpenseNature",
  "kind": "LinkedField",
  "name": "expenseNature",
  "plural": false,
  "selections": (v23/*: any*/),
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "Category",
  "kind": "LinkedField",
  "name": "categoryNode",
  "plural": false,
  "selections": (v23/*: any*/),
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "source",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "performedAt",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "regex",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "concreteType": "Stakeholder",
  "kind": "LinkedField",
  "name": "allStakeholders",
  "plural": true,
  "selections": (v23/*: any*/),
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "concreteType": "ExpenseNature",
  "kind": "LinkedField",
  "name": "expenseNatures",
  "plural": true,
  "selections": (v23/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "stakeholderTxnsDialog_Query",
    "selections": [
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "TransactionsPage",
        "kind": "LinkedField",
        "name": "transactions",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "FilterAccount",
            "kind": "LinkedField",
            "name": "accounts",
            "plural": true,
            "selections": [
              (v9/*: any*/),
              (v10/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CategorizationHealthMonth",
            "kind": "LinkedField",
            "name": "health",
            "plural": true,
            "selections": [
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TransactionRow",
            "kind": "LinkedField",
            "name": "txns",
            "plural": true,
            "selections": [
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "BankAccount",
                "kind": "LinkedField",
                "name": "otherBankAccount",
                "plural": false,
                "selections": [
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              (v22/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Attribution",
                "kind": "LinkedField",
                "name": "attribution",
                "plural": false,
                "selections": [
                  (v26/*: any*/),
                  (v27/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v28/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Rule",
                    "kind": "LinkedField",
                    "name": "rule",
                    "plural": false,
                    "selections": [
                      (v29/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v30/*: any*/),
      (v31/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "stakeholderTxnsDialog_Query",
    "selections": [
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "TransactionsPage",
        "kind": "LinkedField",
        "name": "transactions",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "FilterAccount",
            "kind": "LinkedField",
            "name": "accounts",
            "plural": true,
            "selections": [
              (v9/*: any*/),
              (v10/*: any*/),
              (v15/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CategorizationHealthMonth",
            "kind": "LinkedField",
            "name": "health",
            "plural": true,
            "selections": [
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TransactionRow",
            "kind": "LinkedField",
            "name": "txns",
            "plural": true,
            "selections": [
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "BankAccount",
                "kind": "LinkedField",
                "name": "otherBankAccount",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v15/*: any*/)
                ],
                "storageKey": null
              },
              (v22/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Attribution",
                "kind": "LinkedField",
                "name": "attribution",
                "plural": false,
                "selections": [
                  (v26/*: any*/),
                  (v27/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v28/*: any*/),
                      (v15/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Rule",
                    "kind": "LinkedField",
                    "name": "rule",
                    "plural": false,
                    "selections": [
                      (v29/*: any*/),
                      (v15/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v15/*: any*/)
                ],
                "storageKey": null
              },
              (v15/*: any*/)
            ],
            "storageKey": null
          },
          (v15/*: any*/)
        ],
        "storageKey": null
      },
      (v30/*: any*/),
      (v31/*: any*/)
    ]
  },
  "params": {
    "cacheID": "cb0811a75d6d1bc1decb44680b5135b8",
    "id": null,
    "metadata": {},
    "name": "stakeholderTxnsDialog_Query",
    "operationKind": "query",
    "text": "query stakeholderTxnsDialog_Query(\n  $from: String\n  $accountNumber: String\n  $categorized: Boolean\n  $perspectiveId: ID\n  $counterpartyId: ID\n  $query: String\n) {\n  transactions(from: $from, accountNumber: $accountNumber, categorized: $categorized, perspectiveId: $perspectiveId, counterpartyId: $counterpartyId, query: $query) {\n    totalCount\n    limit\n    accounts {\n      number\n      nickname\n      id\n    }\n    health {\n      period\n      categorized\n      uncategorized\n      internal\n      id\n    }\n    txns {\n      txn {\n        id\n      }\n      postingDate\n      description\n      amount\n      kind\n      accountNumber\n      internal\n      otherBankAccount {\n        number\n        id\n      }\n      classification\n      expenseNature {\n        id\n        name\n      }\n      categoryNode {\n        id\n        name\n      }\n      attribution {\n        source\n        performedAt\n        user {\n          email\n          id\n        }\n        rule {\n          regex\n          id\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n  allStakeholders {\n    id\n    name\n  }\n  expenseNatures {\n    id\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "46202ea1e45278ac326e9886c05f72b2";

export default node;
